/** Static copy for the landing-page workspace mock — avoids i18n key leakage in the hero preview. */
export const HERO_PREVIEW = {
  navSectionPrimary: 'Primary',
  navSectionTools: 'Tools',
  navSectionFooter: 'More',
  sidebarReferrals: 'Referrals',
  sidebarSupport: 'Support',
  sidebarSettings: 'Settings',
  breadcrumbHome: 'Home',
  breadcrumbJobs: 'Jobs',
  breadcrumbAgent: 'Agent',
  dashboardAtsLabel: 'Profile readiness',
  dashboardAtsBadge: 'Room to improve',
  dashboardActionSuggested: 'Action suggested',
  dashboardActionBody: 'Follow up on your Meta PM application — no reply in 5 days.',
  dashboardYourActions: 'Your actions',
  dashboardActionOptimize: 'Optimize resume',
  dashboardActionOptimizeSub: 'Tailor for jobs',
  dashboardActionFindJobs: 'Find jobs',
  dashboardActionFindJobsSub: 'Browse AI matches',
  dashboardActionCoverLetter: 'Cover letter',
  dashboardActionCoverLetterSub: 'Draft per role',
  dashboardActionInterview: 'Prepare interview',
  dashboardActionInterviewSub: 'AI-driven practice',
  dashboardActionTrackPipeline: 'Track pipeline',
  dashboardActionTrackPipelineSub: 'Kanban status',
  dashboardActionApply: 'Review & apply',
  dashboardActionApplySub: 'You control each submission',
  activityTitle: 'Recent activity',
  activitySubtitle: 'Every optimization, application, and outcome in one timeline.',
  activityFilterAll: 'All',
  activityFilterApplied: 'Applied',
  activityFilterOptimized: 'Optimized',
  activityFilterInterview: 'Interview',
  activityShowing: 'Showing 6 of 24 activities',
  activityApplied: 'Applied · Digital Marketing Executive',
  activityOptimized: 'Resume optimized · Lead PM',
  activityInterview: 'Interview prep · Thu 3 PM',
  dashboardTargetedJobs: 'Targeted job matches',
  matchOneTitle: 'Product Manager',
  matchOneCompany: 'Tata Communications · Bengaluru',
  matchTwoTitle: 'Senior Product Manager',
  matchTwoCompany: 'Microsoft · Remote',
  dashboardPipeline: 'My pipeline & analytics',
  dashboardStatApps: 'Applications',
  dashboardStatInterviews: 'Interviews',
  dashboardStatOffers: 'Offers',
  jobsFilterRemote: 'Remote',
  jobsFilterFresh: 'Posted this week',
  jobsRecommendedMeta: '12 jobs ranked for you',
  jobCardApply: 'Apply',
  agentQuery: 'Find senior product manager roles that match my resume and are remote-friendly.',
  you: 'You',
  agentProcessingLabel: 'GoGrabJob Agent',
  stepSearch: 'Searching job boards…',
  agentAnalyzingBody: 'Scanning LinkedIn, Naukri, and company career pages for strong matches.',
  agentReplyTitle: '3 strong matches found',
  agentReplyBody: 'Ranked by skill overlap, ATS fit, and your preferred locations.',
  promptHint: 'Ask the agent to optimize, apply, or prep for any role.',
  matchFeed: 'Your matches',
  liveUpdates: 'Live',
  companionTitle: 'AI Companion',
  companionSubtitle: 'Your voice-enabled coach for matches, outreach, and interview prep.',
  companionCoachName: 'Friendly Coach',
  companionCoachHint: 'Tap speaker on replies to listen',
  companionVoice: 'Sarah (female)',
  companionGreeting: 'How can I help with your job search today?',
  companionReply: 'I can review matches, draft outreach, or run a mock interview.',
  companionUserAskMatches: 'Review my top 3 matches and suggest which to apply first.',
  companionAssistantMatches:
    'Start with the 94% Senior PM role at Stripe — strongest skill overlap and remote-friendly. Meta is second at 89%, then Acme at 86%.',
  companionUserAskOutreach: 'Draft a short outreach note for the Stripe role.',
  companionAssistantOutreach:
    'Hi [Hiring Manager], I tailored my resume for your Senior PM opening — 6 years in B2B SaaS with measurable growth outcomes. Happy to share results if useful.',
  companionInputPlaceholder: 'Ask anything about your search…',
  companionThinking: 'Thinking…',
  prepareTitle: 'Prepare for interview',
  prepareSubtitle: 'Curated mock interviews and video prep for each role you are targeting.',
  prepareJobsLabel: 'Roles to prep',
  prepareActiveSession: 'Active session',
  prepareQuestion: 'Tell me about a time you influenced roadmap without direct authority.',
  prepareCategory: 'Behavioral',
  prepareScoreClarity: 'Clarity',
  prepareScoreStructure: 'Structure',
  prepareScoreRoleFit: 'Role fit',
  prepareUpcoming: 'Upcoming: Product sense mock · Thu 4 PM',
  prepareUpcomingBody: 'AI will score clarity, structure, and role fit.',
  prepareJobOne: 'Senior PM · Stripe',
  prepareJobTwo: 'Lead PM · Microsoft',
  prepareJobThree: 'PM · Acme Corp',
  prepareStart: 'Start prep',
  prepareMock: 'Mock interview',
  prepareQuestions: 'Common questions',
  prepareFeedback: 'Answer feedback',
  calendarTitle: 'Calendar & notes',
  calendarSubtitle: 'Track applications, interviews, and reminders in one place.',
  calendarMonth: 'May 2026',
  calendarEntries: 'Entries',
  calendarNotes: 'Notes',
  calendarAddNotePlaceholder: 'Add a note…',
  calendarNoEntries: 'No entries for this date.',
  calendarInterview: 'PM interview · Acme Corp',
  calendarFollowUp: 'Follow up · Meta application',
  calendarNoteOne: 'Research company metrics before Thursday interview.',
  calendarNoteTwo: 'Update Stripe resume with quantified outcomes.',
  referralsTitle: 'Referrals',
  referralsSubtitle: 'Invite friends and earn credits when they join and optimize.',
  referralsBody: 'Invite friends and earn bonus credits when they optimize their first resume.',
  referralsInviteLink: 'gograbjob.com/r/jane-pm',
  referralsCreditsEarned: 'Credits earned',
  referralsFriendsJoined: 'Friends joined',
  referralsPending: 'Pending',
  referralsJoined: 'Joined',
  referralsRecent: 'Recent referrals',
  referralsNextReward: '3 more invites unlock +50 bonus credits',
  referralsStat: '2 friends joined · 20 credits earned',
  referralsCta: 'Share invite link',
  supportTitle: 'Support',
  supportSubtitle: 'Track tickets and get help from the GoGrabJob team.',
  supportStatOpen: 'Open',
  supportStatProgress: 'In progress',
  supportStatResolved: 'Resolved',
  supportSearchPlaceholder: 'Search tickets…',
  supportPriorityHigh: 'High',
  supportPriorityMedium: 'Medium',
  supportOpen: 'Resume export issue',
  supportResolved: 'Billing question',
  supportNew: 'New ticket',
  settingsTitle: 'Settings',
  settingsPageTitle: 'Profile',
  settingsSubtitle: 'Update profile, job preferences, security, and privacy.',
  settingsProfileSection: 'Profile',
  settingsPhoto: 'Photo',
  settingsPhotoHint: 'Upload photo',
  settingsPhotoMeta: 'JPG, PNG · 5 MB',
  settingsName: 'Name',
  settingsEmail: 'Email',
  settingsPhone: 'Phone',
  settingsGender: 'Gender',
  settingsStreet: 'Street address',
  settingsCity: 'City',
  settingsCountry: 'Country',
  settingsSaveProfile: 'Save profile',
  settingsJobPreferences: 'Job Preferences',
  settingsSkills: 'Skills',
  settingsSkillsHint: 'Up to 20 skills (4/20)',
  settingsDomain: 'Domain',
  settingsJobType: 'Job type',
  settingsExperience: 'Experience level',
  settingsLocation: 'Location',
  settingsRemotePreferred: 'Remote preferred',
  settingsSavePreferences: 'Save preferences',
  settingsSecuritySection: 'Security',
  settingsCurrentPassword: 'Current password',
  settingsNewPassword: 'New password',
  settingsConfirmPassword: 'Confirm new password',
  settingsUpdatePassword: 'Update password',
  settingsPasswordNote: 'Passwords are hashed and never stored in plain text.',
  settingsDataPrivacy: 'Data & privacy',
  settingsDeleteAccount: 'Delete account',
  settingsDeleteAccountBody: 'Permanently remove your account and all associated data.',
  settingsDeleteAccountWarning: 'This action cannot be undone.',
  settingsDeleteMyAccount: 'Delete my account',
  settingsProfile: 'Profile',
  settingsNotifications: 'Notifications',
  settingsSecurity: 'Security',
  settingsBilling: 'Billing & credits',
  navHome: 'Home',
  navJobs: 'Jobs',
  navAgent: 'Agent',
  navCalendar: 'Calendar',
  navCompanion: 'AI Companion',
  navPrepare: 'Prepare',
  navActivity: 'Activity',
  matchLabel: 'Match',
  jobsTitle: 'Jobs for you',
  jobsTabAll: 'All',
  jobsTabSaved: 'Saved (7)',
  jobsSearchPlaceholder: 'Search title, company, skill…',
  jobsFilterAllMatches: 'All matches',
  jobsFilterStrongFit: '75%+ Strong fit',
  jobsFilterFullTime: 'Full-time',
  jobsMoreMatches: '+6 more AI-ranked matches',
  jobsMoreMatchesSub: 'Tailored to your skills & preferred locations',
  jobsBrowseAll: 'Browse all',
  jobsOptimizeApply: 'Optimize & apply',
  jobsShowingMatches: 'Showing 6 of 12 AI-ranked matches',
  jobsSortBestMatch: 'Sort: Best match',
  jobsMissingLabel: 'Missing:',
  jobsExtraSkills: '+{{count}} skills',
  jobsRecentlyPosted: 'Recently posted',
  jobsRemoteFriendly: 'Remote-friendly',
  jobCardSave: 'Save',
  atsComplianceTrend: 'ATS Compliance Trend',
  applicationsTrend: 'Applications trend',
  pipelineFunnelTitle: 'Job search funnel',
  pipelineLast6Months: 'Last 6 months',
  pipelineStageApplied: 'Applied',
  pipelineStageScreen: 'Screen',
  pipelineStageInterview: 'Interview',
  pipelineStageOffer: 'Offer',
  pipelineChipApps: 'Apps',
  pipelineChipInt: 'Int',
  pipelineChipOff: 'Off',
  pipelineResponseRate: 'Response rate',
  pipelineAvgReplyTime: 'Avg reply time',
  pipelineThisWeek: 'This week',
  pipelineWeekMetaFollowUp: 'Meta follow-up',
  pipelineWeekStripeScreen: 'Stripe screen',
  pipelineWeekAmazonPrep: 'Amazon prep',
  marketOverallScore: 'Overall score',
  marketStrong: 'Strong',
  marketAtsScore: 'ATS score',
  marketKeywords: 'Keywords',
  marketFormat: 'Format',
  marketVsMarket: 'Vs market',
  marketYou: 'You',
  marketAvg: 'Avg',
  marketTop10: 'Top 10%',
  resumeAtsPassRate: 'ATS pass rate',
  resumeKeywordCoverage: 'Keyword coverage',
  resumeFormatQuality: 'Format quality',
  resumeStatusGood: 'Good',
  resumeStatusFix: 'Fix',
  resumeImproveNext: 'Improve next',
  resumeImproveHint: 'Add metrics · expand skills',
  resumeUpcoming: 'Upcoming',
  resumeUpcomingInterview: 'Thu 3 PM · Meta interview',
  resumeUpcomingFollowUp: 'Follow up · Stripe app',
  resumeInterviewOffers: '1 interview · 0 offers',
  dashboardInsights: 'Insights',
  dashboardMarketLabel: 'Market',
  dashboardResumeLabel: 'Resume',
  activityColJob: 'Job',
  activityColCompany: 'Company',
  activityColAction: 'Action',
  activityColOutcome: 'Outcome',
  activityColScore: 'Score',
  activityCoverLetterDrafted: 'Cover letter drafted · Lead PM',
  activitySampleCompany: 'Digital Marketing Executive @ Ahsan Solutions',
  activityAppliedMeta: 'Applied 7h ago',
  settingsReadOnly: '(Read-only)',
  settingsWarning: 'Warning:',
  settingsSkillsPlaceholder: 'Type a skill, press Enter or comma',
  settingsGenderValue: 'Prefer not to say',
  companionVoicePrefix: 'Voice ·',
  companionCoachInitials: 'FC',
  locationRemote: 'Remote',
  jobTypeFullTime: 'Full-time',
  salaryNotDisclosed: 'Not disclosed',
  jobsLowMatch: 'Low match',
  expMidSenior: 'Mid-Senior',
  expSenior: 'Senior',
  expStaff: 'Staff',
  expPrincipal: 'Principal',
  expAssociate: 'Associate',
  expGroup: 'Group',
  expLead: 'Lead',
  expSeniorYears: 'Senior · 6+ yrs',
  expMidSeniorYears: 'Mid-Senior · 5–8 yrs',
  expLeadYears: 'Lead · 7+ yrs',
  expStaffYears: 'Staff · 8+ yrs',
  mockSkillsMatch1: 'Product Strategy|Roadmaps|Agile',
  mockSkillsMatch2: 'B2B SaaS|Stakeholders|Analytics',
  mockSkillsStaff: 'Leadership|Platform|GTM',
  mockSkillsPrincipal: 'APIs|Enterprise|Vision',
  mockSkillsAssociate: 'User Research|Metrics|A/B Testing',
  mockSkillsGroup: '0-to-1|Cross-functional|Scale',
  mockSkillsLead: 'Payments|Compliance|APIs',
  mockSkillsGeneric: 'Product Strategy|Product Roadmap',
  mockDescMatch1:
    'Own roadmap for enterprise communications products. Partner with eng and GTM on launches across India and APAC.',
  mockDescMatch2:
    'Drive feature strategy for cloud platform. Work with customers and sales on quarterly priorities and OKRs.',
  mockDescStaff:
    'Lead platform PMs shipping core workflow tools for mid-market customers. Own discovery, delivery, and adoption metrics.',
  mockDescPrincipal:
    'Define multi-year platform vision. Align API strategy with enterprise customer needs and compliance requirements.',
  mockDescAssociate:
    'Support category PMs with experiments, user research, and launch execution for high-traffic shopping flows.',
  mockDescGroup:
    'Own a portfolio of buyer-experience products across web and mobile surfaces. Drive roadmap for search, checkout, and recommendations.',
  mockDescLead:
    'Ship payment acceptance features for global merchants and developer platforms. Collaborate with compliance and risk teams.',
  mockDescGeneric:
    'Own cinema SaaS modules and partner integrations. Improve scheduling, ticketing, and analytics for multiplex operators.',
  atsJobPmTitle: 'Product Manager',
  atsJobPmCompany: 'Tata Communications',
  atsJobPmSkills: 'Product Strategy|Agile|Telecom',
  atsJobPmSalary: '₹28L – ₹36L',
  atsJobPmDescription:
    'Lead enterprise communications product initiatives for India and APAC markets.',
  atsJobPmMatchedSkills: 'Product Strategy|Agile',
  atsJobPmMissingSkills: 'Telecom domain',
  atsJobPmBonusSkills: 'Roadmaps',
  atsJobPmWhy:
    'Strong PM fundamentals match; telecom domain is a minor gap you can address in your summary.',
  atsJobPmActionItems: 'Highlight enterprise launch experience|Apply on company portal',
  atsJobLeadPlatformTitle: 'Lead PM – Platform',
  atsJobLeadPlatformCompany: 'Razorpay',
  atsJobLeadPlatformSkills: 'Platform|GTM|0→1',
  atsJobLeadPlatformSalary: '₹32L – ₹42L',
  atsJobLeadPlatformDescription:
    'Build platform capabilities for mid-market workflow tools from discovery through adoption.',
  atsJobLeadPlatformMatchedSkills: 'Platform|GTM',
  atsJobLeadPlatformMissingSkills: 'Workflow automation',
  atsJobLeadPlatformBonusSkills: 'Analytics',
  atsJobLeadPlatformWhy:
    'Platform PM experience maps well; workflow tooling is learnable from your SaaS background.',
  atsJobLeadPlatformActionItems: 'Optimize for platform keywords|Request intro via Peerlist',
  atsJobStaffMatchedSkills: 'APIs|Enterprise',
  atsJobStaffMissingSkills: 'Compliance frameworks',
  atsJobStaffBonusSkills: 'Roadmapping',
  atsJobStaffWhy:
    'Enterprise PM scope fits your background; compliance can be addressed in your optimized resume.',
  atsJobStaffActionItems: 'Emphasize API launches|Save for later review',
  calendarPrevMonth: 'Previous month',
  calendarNextMonth: 'Next month',
  calendarSelectDay: 'Select May {{day}}',
  calendarAddEntry: 'Add entry',
  supportTicketAgentVariant: 'Agent not saving resume variant',
  supportTicketCreditsReferral: 'Credits not applied after referral',
  supportStatusOpen: 'Open',
  supportStatusResolved: 'Resolved',
  supportStatusInProgress: 'In progress',
  supportFilterAll: 'All',
  referralsSampleOneMeta: 'Joined · +10 credits',
  referralsSampleTwoMeta: 'Signed up · pending optimize',
  referralsSampleThreeMeta: 'Invite sent · 2d ago',
  pointsAbbrev: 'pts',
  pipelineAvgReplySample: '4.2 days',
  scanningForMatches: 'Scanning for matches…',
  strongMatchesFound: '{{count}} strong matches found',
  time7hAgo: '7h ago',
  timeYesterday: 'Yesterday',
  time3dAgo: '3d ago',
  timeMon3pm: 'Mon 3:00 PM',
  time2hAgo: '2h ago',
  time4dAgo: '4d ago',
  timePosted2d: '2d ago',
  timePosted1d: '1d ago',
  timePosted3d: '3d ago',
  timePosted4d: '4d ago',
  timePosted5d: '5d ago',
  timePosted6d: '6d ago',
  timePosted1w: '1w ago',
  mockJobStaffPm: 'Staff Product Manager',
  mockJobPrincipalPm: 'Principal PM',
  mockJobAssociatePm: 'Associate Product Manager',
  mockJobGroupPm: 'Group Product Manager',
  mockJobLeadPm: 'Lead Product Manager',
  mockJobPmGeneric: 'Product Manager',
  mockCompanyGrowthSaaS: 'Growth-stage SaaS',
  mockCompanyEnterprise: 'Enterprise platform',
  mockCompanyFlipkart: 'Flipkart · Hyderabad',
  mockCompanyAmazon: 'Amazon · Remote',
  mockCompanyStripe: 'Stripe · San Francisco',
  mockCompanyQube: 'Qube Cinema',
  agentStripFindJobs: 'Find Jobs',
  agentStripOrTypeYourOwn: 'or type your own',
  activityOutcomeUnknown: 'Unknown',
  activityOutcomeApplied: 'Applied',
  activityOutcomeInterview: 'Interview',
  activityOutcomeSaved: 'Saved',
  activityActionApplied: 'Applied',
  activityActionOptimized: 'Optimized',
  activityActionInterview: 'Interview',
  activityActionSaved: 'Saved',
  activityRowMarketingJob: 'Digital Marketing Executive',
  activityRowLeadPm: 'Lead Product Manager',
  activityRowSeniorPm: 'Senior PM',
  activityRowInterviewPrep: 'PM interview prep',
  activityRowCoverLetterDraft: 'Cover letter draft',
  activityRowSavedMatches: 'Saved job matches',
  activityDate2hAgo: '2h ago',
  activityDateMon: 'Mon',
  activityDateMon3pm: 'Mon 3 PM',
  activityDate4dAgo: '4d ago',
} as const;

export const AGENT_STRIP = {
  findJobs: 'Find Jobs',
  orTypeYourOwn: 'or type your own',
  queries: [
    'Product Manager role in Bangalore',
    'Find jobs relevant for me',
    'Senior backend engineer — remote, 5+ years',
    'Data analyst roles open to relocation',
    'UX designer at a Series B startup',
    'DevOps engineer in Hyderabad',
    'Marketing manager in fintech',
    'Entry-level sales executive in Mumbai',
  ],
} as const;

export type HeroPreviewCopy = typeof HERO_PREVIEW;
